
export default {
  methods: {
    scrollDown() {
      document.querySelector('#header-slider-scroll-to').scrollIntoView()
    },
  },
}
